var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarioinWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    rx: 1,
    transform: "translate(4 8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,2H2A2.006,2.006,0,0,0,0,4V18a2.006,2.006,0,0,0,2,2H18a2.006,2.006,0,0,0,2-2V4a2.006,2.006,0,0,0-2-2M16,6a2.006,2.006,0,0,1,2,2v9a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V8A2.006,2.006,0,0,1,4,6Z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,2H2A2.006,2.006,0,0,0,0,4V18a2.006,2.006,0,0,0,2,2H18a2.006,2.006,0,0,0,2-2V4a2.006,2.006,0,0,0-2-2m1,16a1,1,0,0,1-1,1H2a1,1,0,0,1-1-1V4A1,1,0,0,1,2,3H18a1,1,0,0,1,1,1Z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,0H5A1,1,0,0,1,6,1V3A1,1,0,0,1,4,3V1A1,1,0,0,1,5,0",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,0h0a1,1,0,0,1,1,1V3a1,1,0,0,1-2,0V1a1,1,0,0,1,1-1",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,9v1a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V9A1,1,0,0,1,5,8H6A1,1,0,0,1,7,9",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,9v1a1,1,0,0,1-1,1H9a1,1,0,0,1-1-1V9A1,1,0,0,1,9,8h1a1,1,0,0,1,1,1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,9v1a1,1,0,0,1-1,1H13a1,1,0,0,1-1-1V9a1,1,0,0,1,1-1h1a1,1,0,0,1,1,1",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarioinWhite);
export default __webpack_public_path__ + "static/media/calendario in - white.d8c338f0ebd45a072f7568c2a00e3cf6.svg";
export { ForwardRef as ReactComponent };